import { jsx } from "react/jsx-runtime";
import TableRowsIcon from "@mui/icons-material/TableRows";
import { validateTidalLicense } from "../../base/index.js";
function TableRows(props) {
  return /* @__PURE__ */ jsx(
    TableRowsIcon,
    {
      "data-testid": "TableRows",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "TableRows",
      "data-tidal-icon-meta": "layout"
    }
  );
}
TableRows.tidalIconMeta = {
  categories: "layout",
  name: "TableRows"
};
validateTidalLicense();
export {
  TableRows
};
//# sourceMappingURL=TableRows.js.map
